// Google Analytics event tracking utility
declare global {
  interface Window {
    gtag?: (
      command: 'event' | 'config' | 'set' | 'consent',
      targetId: string,
      config?: Record<string, any>
    ) => void;
  }
}

const isDevelopment = process.env.NODE_ENV === 'development';
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname === '');

export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  // Disable analytics in development or on localhost
  if (isDevelopment || isLocalhost) {
    console.log('[Analytics - Disabled in Dev]', eventName, eventParams);
    return;
  }

  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('event', eventName, eventParams);
    } catch (error) {
      console.error('Analytics error:', error);
    }
  }
};

export const setAnalyticsConsent = (granted: boolean) => {
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied',
      });
    } catch (error) {
      console.error('Analytics consent error:', error);
    }
  }
};

// Story-specific events
export const trackStoryView = (storyId: string, storyTitle: string, city: string, intensity: number) => {
  trackEvent('story_view', {
    story_id: storyId,
    story_title: storyTitle,
    city: city,
    intensity: intensity,
  });
};

export const trackStoryRead = (storyId: string, readTime: string) => {
  trackEvent('story_read_complete', {
    story_id: storyId,
    read_time: readTime,
  });
};

export const trackThemeToggle = (theme: 'light' | 'dark') => {
  trackEvent('theme_toggle', {
    theme: theme,
  });
};

export const trackDonationClick = (location: string = 'header') => {
  trackEvent('donation_click', {
    button_location: location,
  });
};

export const trackTagFilter = (tag: string) => {
  trackEvent('tag_filter', {
    tag: tag,
  });
};

export const trackShareStory = (storyId: string, platform: string) => {
  trackEvent('share_story', {
    story_id: storyId,
    platform: platform,
  });
};

export const trackNavigationClick = (destination: string, source: string = 'header') => {
  trackEvent('navigation_click', {
    destination: destination,
    source: source,
  });
};
